import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import { Tooltip } from '@mui/material'

export default function AutomaticConciliationButton({ isAutomaticConciliation, isAutomaticConciliationSwitchDisabled, handleAutomaticConciliationClick, isUpdatingAutomaticConciliation, isRunningRemunerationConciliation, isRunningTransferConciliation, isRunningF29Conciliation, label = 'Conciliaci?n Autom?tica' }) {
 return (
                <div className='flex flex-col items-start gap-1 sm:items-center'>
                  <Tooltip
                    arrow
                    title='Conciliación Automática'
                  >
                    <span className='inline-flex max-w-full'>
                      <button
                        type='button'
                        onClick={handleAutomaticConciliationClick}
                        disabled={isAutomaticConciliationSwitchDisabled}
                        aria-label='Conciliación Automática'
                        aria-pressed={isAutomaticConciliation}
                        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white shadow-full-xs transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 ${
                          isAutomaticConciliation
                            ? 'bg-accent2 focus-visible:ring-accent2'
                            : 'bg-accent3 focus-visible:ring-accent3'
                        } ${
                          isAutomaticConciliationSwitchDisabled
                            ? 'cursor-not-allowed opacity-50'
                            : 'cursor-pointer hover:bg-opacity-80'
                        }`}
                      >
                        <PowerSettingsNewIcon fontSize='small' />
                      </button>
                    </span>
                  </Tooltip>
                  <span className='w-9 text-center text-xs font-semibold text-gray-500'>
                    {isAutomaticConciliation ? 'ON' : 'OFF'}
                  </span>
                  {(isUpdatingAutomaticConciliation ||
                    isRunningRemunerationConciliation ||
                    isRunningTransferConciliation ||
                    isRunningF29Conciliation) && (
                    <span className='text-xs font-sans text-gray-500'>
                      {isUpdatingAutomaticConciliation
                        ? 'Actualizando...'
                        : 'Resolviendo conciliaciones...'}
                    </span>
                  )}
                </div>
 )
}
